module.exports = __webpack_public_path__ + "img/curve-down.6201a69a.svg";